import { Checkbox as ChakraCheckbox } from "@chakra-ui/react";
import type { ComponentPropsWithRef } from "react";

export type CheckboxProps = ComponentPropsWithRef<typeof ChakraCheckbox>;

export function Checkbox(props: CheckboxProps) {
  return <ChakraCheckbox {...props} />;
}
